module.exports = __webpack_public_path__ + "static/media/logotext-neg.c0176c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logotext-neg.png
// module id = 801
// module chunks = 0